import Api from './Api'

class DoujinApi extends Api {
  static list(params) {
    return this.get('/albums', params)
  }

  static details(slug, params) {
    return this.get('/album/' + slug, params).then(res =>
      Api.adjustMeta(res, 'doujin-show')
    )
  }

  static pages(slug, params) {
    return this.get('/album/' + slug + '/pages', params).then(res =>
      Api.adjustMeta(res, 'doujin-show')
    )
  }

  static related(slug, params) {
    return this.get('/album/' + slug + '/recommendations', {
      ...params,
      limit: 24
    }).then(res => Api.adjustMeta(res, 'doujin-show'))
  }
}

export default DoujinApi
